export interface AnalyticsMetadataResource {
  id: number
  metadata: Record<string, unknown>
}
